import mountVueInstance from './mountVueInstance'

function errorLoadPage (
  Vue,
  ErrorPage,
  errorCode = '500',
  errorText = '服务器异常，请联系管理员',
  vueOptions) {
  mountVueInstance(Vue, {
    render: h => h(ErrorPage, { props: { code: errorCode, text: errorText } }, null)
  }, vueOptions)
}

export default errorLoadPage
